import React from "react";
import pageStyles from "../styles/PageLayout.module.css";
import PageHeader from "../shared/PageHeader";
import PageContent from "../shared/PageContent";
import PhotosessionSection from "../sections/PhotosessionSection";

export function PhotosessionPage({ photosession }) {
  return (
    <div className={pageStyles.page}>
      <PageHeader
        title="Фотосессия"
        description="Настраивайте стоимость AI-фотосессии, видимые стили и вложения превью."
      />
      <PageContent>
        <PhotosessionSection mode="page" state={photosession.state} actions={photosession.actions} />
      </PageContent>
    </div>
  );
}

export default PhotosessionPage;
